import React, { useState, useEffect, useRef } from "react";
import classes from "./PromotionData.module.css";
import Navbar from "../Components/Navbar";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { misData, promotionCount, promotionData } from "../Services/Apis";
import axios from "axios";
import { Calendar } from "primereact/calendar";

const PromotionData = () => {
  const [count, setCount] = useState([]);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());


  const [startDate2, setStartDate2] = useState(new Date());
  const [endDate2, setEndDate2] = useState(new Date());
  const [data, setData] = useState([]);

  console.log(data);

  // Ref for PrimeReact Calendar
const countCalendarRef = useRef(null);
const startCalendarRef = useRef(null);
const endCalendarRef = useRef(null);
  const getPromotionCount = async () => {
    // console.log(date);
    // console.log(formattedDate);

      const formattedDate1 = new Date(startDate2).toLocaleDateString("en-CA");
    const formattedDate2 = new Date(endDate2).toLocaleDateString("en-CA");
    // console.log(formattedDate);


    try {
      const res = await axios.get(
        `${promotionCount}?fromDate=${formattedDate1}&toDate=${formattedDate2}`
      );
      console.log(res.data);
      setCount(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  const getPromotionData = async () => {
    // console.log(date);
    const formattedDate1 = new Date(startDate).toLocaleDateString("en-CA");
    const formattedDate2 = new Date(endDate).toLocaleDateString("en-CA");
    // console.log(formattedDate);

   

    try {
      const res = await axios.get(
        `${promotionData}?fromDate=${formattedDate1}&toDate=${formattedDate2}`
      );
      console.log(res.data.promotion);
      setData(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getPromotionCount();
  }, [startDate2, endDate2]);

  useEffect(() => {
    getPromotionData();
  }, [startDate, endDate]);

  // Function to show the calendar popup on icon click

  console.log(data,count,'data-------------------')
  

  return (
    <div className={classes.container}>
      <Navbar />
      <div className={classes.main}>
        <p className={classes.title}>
          PUBLISHER TRAFFIC
          {/* of {new Date(date).toLocaleDateString('en-CA')} */}
        </p>

         <div className={classes.inputs_dates}>
          <div className={classes.input_div}>
            {/* Assign ref to Calendar component */}
            <Calendar
              ref={startCalendarRef}
              value={startDate2}
              maxDate={new Date()}
              onChange={(e) => setStartDate2(e.value)}
              dateFormat="dd/mm/yy"
              className={classes.input}
              // This will also add a default calendar icon
            />

            {/* Custom icon to trigger calendar */}
            <i
              className="pi pi-calendar-clock"
              onClick={() => startCalendarRef.current.show()}
              style={{ cursor: "pointer", marginLeft: "10px" }}
            ></i>
          </div>
          <div className={classes.input_div}>
            {/* Assign ref to Calendar component */}
            <Calendar
              ref={endCalendarRef}
              value={endDate2}
              maxDate={new Date()}
              onChange={(e) => setEndDate2(e.value)}
              dateFormat="dd/mm/yy"
              className={classes.input}
              // This will also add a default calendar icon
            />

            {/* Custom icon to trigger calendar */}
            <i
              className="pi pi-calendar-clock"
              onClick={() => endCalendarRef.current.show()}
              style={{ cursor: "pointer", marginLeft: "10px" }}
            ></i>
          </div>
        </div>


         <DataTable
          value={count}
          showGridlines
          tableStyle={{ minWidth: "50rem" }}
          className="w-90 custom-table rounded-md text-center"
        >
          <Column
            field="date"
            header="DATE"
            alignHeader="center"
            headerClassName="bg-gray-300"
          ></Column>
          <Column
            field="count"
            header="Count"
            alignHeader="center"
            headerClassName="bg-gray-300"
          ></Column>
          
        </DataTable>




        <p className={classes.title}>
          PROMOTION DATA
          {/* of {new Date(date).toLocaleDateString('en-CA')} */}
        </p>

        <div className={classes.inputs_dates}>
          <div className={classes.input_div}>
            {/* Assign ref to Calendar component */}
            <Calendar
              ref={startCalendarRef}
              value={startDate}
              maxDate={new Date()}
              onChange={(e) => setStartDate(e.value)}
              dateFormat="dd/mm/yy"
              className={classes.input}
              // This will also add a default calendar icon
            />

            {/* Custom icon to trigger calendar */}
            <i
              className="pi pi-calendar-clock"
              onClick={() => startCalendarRef.current.show()}
              style={{ cursor: "pointer", marginLeft: "10px" }}
            ></i>
          </div>
          <div className={classes.input_div}>
            {/* Assign ref to Calendar component */}
            <Calendar
              ref={endCalendarRef}
              value={endDate}
              maxDate={new Date()}
              onChange={(e) => setEndDate(e.value)}
              dateFormat="dd/mm/yy"
              className={classes.input}
              // This will also add a default calendar icon
            />

            {/* Custom icon to trigger calendar */}
            <i
              className="pi pi-calendar-clock"
              onClick={() => endCalendarRef.current.show()}
              style={{ cursor: "pointer", marginLeft: "10px" }}
            ></i>
          </div>
        </div>

        <DataTable
          value={data}
          showGridlines
          tableStyle={{ minWidth: "50rem" }}
          className="w-full custom-table rounded-md text-center"
        >
          <Column
            field="partner"
            header="Partner"
            alignHeader="center"
            headerClassName="bg-gray-300"
          ></Column>
          <Column
            field="serviceName"
            header="serviceName"
            alignHeader="center"
            headerClassName="bg-gray-300"
          ></Column>
          <Column
            field="date"
            header="DATE"
            alignHeader="center"
            headerClassName="bg-gray-300 "
          
          />
          <Column
            field="subscription"
            header="Total"
            alignHeader="center"
            headerClassName="bg-gray-300"
          ></Column>
        </DataTable>
      </div>
    </div>
  );
};

export default PromotionData;
